import React, { useEffect, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import "./Account.css";
import { FaUserCircle } from "react-icons/fa";
import { IoLockClosed } from "react-icons/io5";
import { IoLockOpen } from "react-icons/io5";
import ActivateAccDrawer from "../Drawers/ActivateAccDrawer";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import moment from "moment";
import Navbar from "../../Components/Navbar/Navbar";
import Dropdown from "../Dropdown/Dropdown";

// Status DropDown Data
const StatusDropdown = [
  {
    name: "All",
  },
  {
    name: "Pending",
  },
  {
    name: "Approved",
  },
  {
    name: "Rejected",
  },

  {
    name: "Not Uploaded",
  },
];

const Account = () => {
  const [searchValue, setSearchValue] = useState("");
  const [listUser, setListUser] = useState();
  const [accountId, setAccountId] = useState();
  const [status, setStatus] = useState();
  const [listUserDep, setListUserDep] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("");

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const navigate = useNavigate();
  const goToAccDetail = (accountDetail) => {
    localStorage.setItem("accountDetail", JSON.stringify(accountDetail));
    navigate("/account-detail", {
      state: { AccountId: accountDetail.id },
    });
  };

  const getAllUser = async () => {
    try {
      const allUser = await servicePost(
        "adminauth/listofallusers",
        {},
        notification,
        authToken
      );

      const sortedUsers = allUser?.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      setListUser(sortedUsers);
      // setListUser(sortedUsers.reverse());
    } catch (error) {
      console.log("err", error);
    }
  };
  useEffect(() => {
    getAllUser();
  }, [listUserDep]);

  const lockUnlock = async (checkStatus, accountId) => {
    console.log("checkStatus=", checkStatus);
    console.log("accountId=", accountId);
    if (checkStatus == "activate") {
      let updateLockStatus = await servicePost(
        "adminauth/activate_deactivateuser",
        { accountId, status: "activate" },
        notification,
        authToken
      );
      setListUserDep(listUserDep + 1);
    } else if (checkStatus == "deactivate") {
      let updateUnlockLockStatus = await servicePost(
        "adminauth/activate_deactivateuser",
        { accountId, status: "deactivate" },
        notification,
        authToken
      );
      setListUserDep(listUserDep + 1);
    }
  };

  // Function to filter users based on searchValue
  // const filteredUsers = listUser?.filter((user) => {
  //   const fullName = user?.fullName?.toLowerCase() || "";
  //   const email = user?.email?.toLowerCase() || "";
  //   const accountId = String(user?.id || "");
  //   const search = searchValue?.toLowerCase();

  //   return (
  //     fullName?.includes(search) ||
  //     email?.includes(search) ||
  //     accountId?.includes(search)
  //   );
  // });

  const filteredUsers = listUser?.filter((user) => {
    const fullName = user?.fullName?.toLowerCase() || "";
    const email = user?.email?.toLowerCase() || "";
    const accountId = String(user?.id || "");
    const search = searchValue?.toLowerCase();

    // Treat null postPaidStatus as "Processing"
    const userStatus = user?.postPaidStatus || "Not Uploaded";

    const searchMatch =
      fullName.includes(search) ||
      email.includes(search) ||
      accountId.includes(search);

    const statusMatch =
      selectedStatus === "All" ||
      selectedStatus === "" ||
      selectedStatus === userStatus;

    return searchMatch && statusMatch;
  });

  const handleDropdownChange = (field) => (value) => {
    if (field === "Status") {
      setSelectedStatus(value);
    }
  };

  return (
    <>
      <div
        className="offcanvas offcanvas-end offcanvas-custom"
        tabIndex="-1"
        id="ActivateAcc"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h5 id="offcanvasRightLabel"> Confirmation </h5>
          {/* <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button> */}

          <svg
            className="drawer-cross-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            xmlns="http://www.w3.org/2000/svg"
            width="38.894"
            height="38.894"
            viewBox="0 0 38.894 38.894"
          >
            <path
              id="Path_18510"
              data-name="Path 18510"
              d="M38.894,18.763v1.367c-.03.2-.066.4-.087.595-.062.577-.087,1.16-.18,1.732a18.957,18.957,0,0,1-4.2,9.313,19.088,19.088,0,0,1-12.867,6.963c-.475.055-.95.107-1.425.161H18.763c-.589-.06-1.18-.1-1.766-.184A19.039,19.039,0,0,1,7.48,34.7,19.112,19.112,0,0,1,.16,21.555Q.08,20.881,0,20.207V18.687c.029-.173.064-.345.087-.518.115-.875.165-1.764.349-2.624A19.178,19.178,0,0,1,8.516,3.423,18.658,18.658,0,0,1,17.3.163C17.788.11,18.275.054,18.763,0h1.367c.173.028.346.065.52.083.6.062,1.212.082,1.808.181A19.116,19.116,0,0,1,32.821,5.4a19.035,19.035,0,0,1,5.913,11.935q.08.712.16,1.425m-21.765.7c-.32.306-.617.579-.9.863q-1.963,1.957-3.92,3.921A1.655,1.655,0,0,0,13.23,27.1a1.668,1.668,0,0,0,1.464-.56q2.226-2.232,4.457-4.458c.1-.1.2-.185.348-.327a3.961,3.961,0,0,0,.281.359q2.225,2.232,4.457,4.458a1.628,1.628,0,0,0,2.109.283,1.645,1.645,0,0,0,.231-2.615c-1.487-1.5-2.987-2.992-4.481-4.487-.1-.1-.186-.2-.321-.344.238-.221.465-.42.679-.633q2.057-2.051,4.108-4.109a1.655,1.655,0,1,0-2.334-2.34q-2.248,2.236-4.486,4.483c-.095.095-.2.184-.315.294-.892-.9-1.756-1.771-2.622-2.64-.724-.726-1.446-1.454-2.177-2.173a1.583,1.583,0,0,0-1.7-.431,1.6,1.6,0,0,0-1.131,1.352,1.651,1.651,0,0,0,.547,1.467c1.577,1.573,3.151,3.149,4.789,4.787"
              fill="#00A19B"
            />
          </svg>
        </div>
        <div className="offcanvas-body">
          <ActivateAccDrawer
            lockUnlock={lockUnlock}
            accountId={accountId}
            status={status}
          />
        </div>
      </div>

      <Navbar />
      <div className="account-page-wrapper">
        <Sidebar />
        <div className="container">
          <div className="spacing-wrapper">
            <div className="admin-page-header">
              <img src="./images/icons/admin-user-icon.png" alt="icon" />
              <h2>Accounts/Client </h2>
            </div>

            <div className="account-header-right-main-wrap">
              <div className="account-header-status-filter">
                <Dropdown
                  onTypeChange={handleDropdownChange("Status")}
                  label="Postpaid Status"
                  data={StatusDropdown}
                />
              </div>

              <div className="account-search-main-wrap">
                <div className="search-icon">
                  <img src="./images/icons/search-icon.svg" alt="icon" />
                </div>
                <input
                  onChange={(e) => setSearchValue(e.target.value)}
                  value={searchValue}
                  type="text"
                  placeholder="Search by name, email, or etc"
                />
              </div>
            </div>
            <div className="account-table-wrapper table-responsive">
              {/* <div className="account-table-header">
                <div className="show-entries-text"></div>
              </div> */}

              <table id="principle" className="table table-striped">
                <thead>
                  <tr>
                    <th> ID </th>
                    <th> Name </th>
                    <th> Email </th>
                    <th>Phone</th>
                    <th>Postpaid</th>
                    {/* <th>Country</th>
                    <th>DOB</th>
                    <th>Post</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredUsers?.length > 0 ? (
                    filteredUsers?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.id} </td>
                          <td>{data.fullName}</td>
                          <td>{data.email}</td>
                          <td>{data.phone}</td>
                          <td>
                            <div className="">
                              {data?.postPaidStatus == "Approved" ? (
                                <img
                                  src="./images/icons/status-complete.svg"
                                  alt="icon"
                                />
                              ) : data?.postPaidStatus == "Rejected" ? (
                                <img
                                  src="./images/icons/status-cancel.svg"
                                  alt="icon"
                                />
                              ) : data?.postPaidDoc ? (
                                <img
                                  src="./images/icons/status-pending.svg"
                                  alt="icon"
                                />
                              ) : (
                                <img
                                  className="not-uploaded-icon"
                                  src="./images/icons/not-uploaded.png"
                                  alt="icon"
                                />
                              )}
                            </div>
                          </td>
                          {/* <td> {moment(data.CreatedAt).format("Y-M-D")}</td>
                          <td>{data.Country}</td>
                          <td>{moment(data.DateOfBirth).format("Y-M-D")}</td>
                          <td>
                            <button
                              className={`${
                                data.AccountType_Id === 1
                                  ? "status-No-verify"
                                  : data.AccountType_Id === 2
                                  ? "status-verify"
                                  : data.AccountType_Id === 3
                                  ? "status-upload"
                                  : data.AccountType_Id === 4
                                  ? "rejected-application"
                                  : "status-No-verify"
                              }`}
                            >
                              {`${
                                data.AccountType_Id === 1
                                  ? "Not Verified"
                                  : data.AccountType_Id === 2
                                  ? "Verified"
                                  : data.AccountType_Id === 3
                                  ? " Doc.uploaded"
                                  : data.AccountType_Id === 4
                                  ? "Rejected"
                                  : "Not Verified"
                              }`}
                            </button>
                          </td> */}
                          <td>
                            <div className="action-icons">
                              <FaUserCircle
                                onClick={() => goToAccDetail(data)}
                              />
                              {data.accountEnabled == false ? (
                                <IoLockClosed
                                  id="customizedate"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#ActivateAcc"
                                  aria-controls="customizeDatecanvasRight"
                                  onClick={() => {
                                    setAccountId(data.id);
                                    setStatus("activate");
                                  }}
                                />
                              ) : (
                                <IoLockOpen
                                  id="customizedate"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#ActivateAcc"
                                  aria-controls="customizeDatecanvasRight"
                                  onClick={() => {
                                    setAccountId(data.id);
                                    setStatus("deactivate");
                                  }}
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;
